import React, { useState } from 'react';
import { X, MessageSquare, Send } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../mock';
import { toast } from 'sonner';

const FloatingContactForm = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${API_URL}/api/contact/consultation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message
        }),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success(data.message || 'Thank you! We will contact you within 24 hours.');
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: ''
        });
        setIsOpen(false);
      } else {
        toast.error(data.detail || 'Failed to send your request. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting consultation:', error);
      toast.error('An error occurred. Please try again later.');
    }
  };

  return (
    <>
      {/* Floating Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-8 right-8 z-50 bg-[#0099FF] hover:bg-[#0077CC] text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 group"
          aria-label="Quick Consultation"
        >
          <MessageSquare size={24} className="group-hover:rotate-12 transition-transform duration-300" />
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-pulse"></span>
        </button>
      )}

      {/* Floating Form */}
      {isOpen && (
        <div className="fixed bottom-8 right-8 z-50 w-[380px] bg-white border border-gray-200 shadow-2xl rounded-lg overflow-hidden animate-in slide-in-from-bottom-5 duration-300">
          {/* Header */}
          <div className="bg-[#0099FF] text-white p-4 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <MessageSquare size={20} />
              <h3 className="font-semibold">Quick Consultation</h3>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="hover:bg-white/20 p-1 rounded transition-colors duration-200"
            >
              <X size={20} />
            </button>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="p-4 space-y-3">
            <div>
              <input
                type="text"
                name="name"
                required
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Your Name *"
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 px-3 py-2 text-sm focus:outline-none focus:border-[#0099FF] transition-colors duration-300 rounded-none"
              />
            </div>

            <div>
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email Address *"
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 px-3 py-2 text-sm focus:outline-none focus:border-[#0099FF] transition-colors duration-300 rounded-none"
              />
            </div>

            <div>
              <input
                type="tel"
                name="phone"
                required
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Phone Number *"
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 px-3 py-2 text-sm focus:outline-none focus:border-[#0099FF] transition-colors duration-300 rounded-none"
              />
            </div>

            <div>
              <textarea
                name="message"
                rows="3"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="How can we help you?"
                className="w-full bg-gray-50 border border-gray-300 text-gray-900 px-3 py-2 text-sm focus:outline-none focus:border-[#0099FF] transition-colors duration-300 rounded-none resize-none"
              ></textarea>
            </div>

            <Button 
              type="submit"
              className="w-full bg-[#0099FF] hover:bg-[#0077CC] text-white font-medium px-4 py-2 rounded-none transition-all duration-400 flex items-center justify-center gap-2 group"
            >
              <span>Send Message</span>
              <Send size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
            </Button>

            {/* Contact Info */}
            <div className="pt-3 border-t border-gray-200 text-center">
              <p className="text-xs text-gray-600 mb-2">Or contact us directly:</p>
              <a href="mailto:info@rstandco.co.in" className="text-[#0099FF] hover:text-[#0077CC] text-sm font-medium transition-colors duration-300 block mb-1">
                info@rstandco.co.in
              </a>
              <a href={`tel:${companyInfo.phone}`} className="text-[#0099FF] hover:text-[#0077CC] text-sm font-medium transition-colors duration-300">
                {companyInfo.phone}
              </a>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default FloatingContactForm;
